(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.contact-form__form');
    const btn = form ? form.querySelector('.contact-form__submit-btn') : null;
    const modal = document.getElementById('inquiry-success-modal');
    const iframe = document.querySelector('iframe[name="contact-form-iframe"]');

    if (!form || !btn || !modal || !iframe) return;

    form.addEventListener('submit', function () {
      // 验证必填项
      const email = form.querySelector('#ContactForm-email');
      if (!email || !email.value) return;

      // 按钮 loading 状态
      btn.classList.add('loading');
      btn.querySelector('.btn-text').style.display = 'none';
      btn.querySelector('.btn-loading').style.display = 'inline';

      // iframe 加载完成后显示对话框
      iframe.onload = function () {
        setTimeout(function () {
          modal.style.display = 'block';
          form.reset();
          btn.classList.remove('loading');
          btn.querySelector('.btn-text').style.display = 'inline';
          btn.querySelector('.btn-loading').style.display = 'none';
        }, 300);
      };
    });

    // 点击遮罩关闭
    modal.querySelector('.inquiry-modal-overlay').addEventListener('click', function () {
      modal.style.display = 'none';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
